'use strict';
require('./section-handler-widget');

const mmWidgets = require('./mm-widgets');

mmWidgets.fn.sendToGoogleDriveWidget = function (googleDriveService, googleDrivePageController, genericUrlPrefix, navigatorShim, ajaxBlobFetch) {
	return mmWidgets.each(this, function () {
		let lastSavedId = false;
		const self = this,
			fileNameField = self.find('[data-mm-role~=send-to-drive-file-name]'),
			urlField =  self.find('[data-mm-role~=send-to-drive-url]'),
			convertibleTypes = [
				'application/vnd.openxmlformats-officedocument.presentationml.presentation',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			],
			mimeTypeForBlob = function (blob) {
				if (convertibleTypes.includes(blob.type)) {
					return 'application/vnd.google-apps.document';
				}
				return blob.type;
			},
			fileName = function () {
				let result = !fileNameField.hasClass('validation-error') && fileNameField.val();
				if (result) {
					result = result.trim();
				}
				return result;
			},
			setStatusMessage = function (message, progress) {
				self.find('[data-mm-role~=send-to-drive-status]').text(message + ' ' + (progress || ''));
			},
			transferFile = function () {
				const uploadOptions = {
						notify: function (percentComplete) {
							setStatusMessage ('Uploading content', percentComplete);
						}
					},
					uploadError = function (errorCode) {
						if (errorCode === 'not-authenticated') {
							self.showSection('send-to-drive-unauthorised');
						} else {
							setStatusMessage ('File upload failed', errorCode);
							self.showSection('send-to-drive-error');
						}
					},
					uploadCompleted = function (result) {
						self.find('[data-mm-role~=send-to-drive-result-link]').attr('href', result.alternateLink || (genericUrlPrefix + result.id));
						lastSavedId = result.id;
						self.showSection('send-to-drive-done');
					},
					uploadBlob = function (blob) {
						return googleDriveService.binaryUpload(blob.response, fileName(), mimeTypeForBlob(blob), uploadOptions).then(uploadCompleted, uploadError);
					},
					downloadOptions = {
						notify: function (percentComplete) {
							setStatusMessage ('Retrieving file', percentComplete);
						}
					},
					downloadError = function (reason) {
						setStatusMessage ('File retrieval failed', reason && reason.statusText);
						self.showSection('send-to-drive-error');
					};
				return ajaxBlobFetch(urlField.val(), navigatorShim, downloadOptions).then(uploadBlob, downloadError);
			},
			start = function () {
				lastSavedId = false;
				if (fileName()) {
					self.showSection('send-to-drive-progress');
					transferFile();
				}
			};
		self.find('[data-mm-role=send-to-drive-kickoff]').click(start);

		self.find('[data-mm-role=send-to-drive-share]').click(function () {
			googleDrivePageController.requestSharingSettings(lastSavedId);
		});
	});
};
